module.exports = __webpack_public_path__ + "static/media/arrival-departure-board2.56cbc6c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/structures/arrival-departure-board2.png
// module id = 125
// module chunks = 0